import { isSafeAnnouncementLink } from '@gto/announcement-ui'

/**
 * The message for a link no customer surface would render, or null when the
 * shape is fine. A blank link passes — presence is a separate rule, and reporting
 * a missing link as malformed tells the operator to fix the wrong thing.
 */
export const validateCtaLinkShape = (link: string): string | null => {
  const trimmed = link.trim()
  if (trimmed === '' || isSafeAnnouncementLink(trimmed)) {
    return null
  }

  return 'Use a full https:// URL or an in-app path starting with "/" — anything else renders no button at all.'
}
